// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f04b034d","268":"469c55d6","358":"09675ef6","457":"54392839","488":"97fd5a31","596":"c35869e8","842":"83774770","851":"9386f248"}[chunkId] + ".chunk.js";
};